var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.onclick}},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isShowTips)?_c('label',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]):_vm._e(),_c('label',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('i',{staticClass:"indicator iconfont"},[_vm._v("")])])
}
var staticRenderFns = []

export { render, staticRenderFns }